import LinkLight from './LinkLight';

export default LinkLight;
